var render = function render(){var _vm=this,_c=_vm._self._c;return _c('servicos',{attrs:{"permitirAprovar":_vm.$temAcessoView('GESCON-UABS-SERV-00'),"permitirReprovar":_vm.$temAcessoView('GESCON-UABS-SERV-00'),"permiteDetalhar":_vm.$temAcessoView('GESCON-UABS-SERV-00'),"rotaDetalhar":"Gescon_Uabs_Servicos_Detalhar","rotaListagem":"Gescon_Uabs_Servicos_Listagem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }